import { Model } from '@shared/models/model';
import { Expose } from 'class-transformer';

export class ExportedFile extends Model {
  /** Inline SAS url — use it when opening the file in a new tab. */
  @Expose() fileUri: string;
  /** SAS url carrying `Content-Disposition: attachment` and the real file name — use it when downloading. */
  @Expose() downloadUri: string;
  @Expose() message: string;
}
